import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowDownSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...others
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 7"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...others}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.25885 0.000124748C1.58845 -0.00273389 1.90679 0.122374 2.14942 0.350113L6.00656 4.06612L9.85685 0.354488C10.0992 0.126544 10.4166 0 10.7461 0C11.0756 0 11.3931 0.126544 11.6354 0.354488C11.7517 0.463649 11.8446 0.59626 11.9081 0.743932C11.9716 0.891604 12.0044 1.05112 12.0044 1.2124C12.0044 1.37367 11.9716 1.53319 11.9081 1.68086C11.8446 1.82854 11.7517 1.96115 11.6354 2.07031L6.89113 6.64378C6.64966 6.87275 6.33228 7 6.00271 7C5.67313 7 5.35575 6.87275 5.11428 6.64378L0.371706 2.07031C0.255178 1.96129 0.162132 1.82872 0.0984779 1.68103C0.0348239 1.53334 0.00195312 1.37375 0.00195312 1.2124C0.00195312 1.05104 0.0348239 0.891455 0.0984779 0.743763C0.162132 0.596072 0.255178 0.463507 0.371706 0.354488C0.612533 0.12553 0.929756 -0.00118209 1.25885 0.000124748Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ArrowDownSVG;
